import React from "react";
import ReactTable from "../../../AppComponent/Table";
import completed_icons from "../../../../Assets/AppComponent/new_dashboard/completed_icons.svg";
import decline_icons from "../../../../Assets/AppComponent/new_dashboard/decline_icon.svg";
import pending_icons from "../../../../Assets/AppComponent/new_dashboard/pending_icon.svg";
import exits_icons from "../../../../Assets/AppComponent/new_dashboard/exit_icon.svg";
import employee_icons from "../../../../Assets/AppComponent/new_dashboard/employee_icons_.svg";
import OnboardingGraph from "./OnboardingGraph";

const Onboardingdetails = () => {
  // COLUMNS
  const columns = [
    { Header: "Position", accessor: "position" },
    { Header: "State", accessor: "state" },
    { Header: "Employees", accessor: "employees" },
  ];

  // DATA
  const data = [
    { position: "01", state: "Tamilnadu", employees: "15,25,000" },
    { position: "02", state: "Karnataka", employees: "10,52,263" },
    { position: "03", state: "Kerala", employees: "7,12,502" },
    { position: "04", state: "Maharastra", employees: "1,56,000" },
    { position: "05", state: "Telugana", employees: "50,000" },
  ];

  return (
    <div className="onboarding-panel">
      <h5>ONBOARDING</h5>

      <div className="total-employees-box">
        <div className="icon">
          <img src={employee_icons} />
        </div>
        <span>Total Employees</span>
        <div className="count">500</div>
      </div>

      {/* Counts */}
      <div className="status-box">
        <div className="item">
          <p>
            Complete <img src={completed_icons} alt="complete" />
          </p>
          <h3>400</h3>
        </div>

        <div className="divider" />

        <div className="item">
          <p>
            Decline <img src={decline_icons} alt="decline" />
          </p>
          <h3>20</h3>
        </div>

        <div className="divider" />

        <div className="item">
          <p>
            Pending <img src={pending_icons} alt="pending" />
          </p>
          <h3>60</h3>
        </div>

        <div className="divider" />

        <div className="item">
          <p>
            Exit <img src={exits_icons} alt="exit" />
          </p>
          <h3>20</h3>
        </div>
      </div>
      {/* 
      <div className="table-section">
        <h5>All TOP ONBOARDINGS</h5>

        <ReactTable data={data} columns={columns} />
      </div> */}

      <div className="table-section">
        <OnboardingGraph />
      </div>
    </div>
  );
};

export default Onboardingdetails;
